// 公共变量
import GlobalVariable from '@/global/global-variable'
import ApiFileLocal from "./api-file-local";

// 查询气体
const searchSensorApi = GlobalVariable.BASE_PATH + "/rest/gas/search";

// 添加气体
const addSensorApi = GlobalVariable.BASE_PATH + "/rest/gas/add";

// 修改气体
const updateSensorApi = GlobalVariable.BASE_PATH + "/rest/gas/update";

// 删除气体
const deleteSensorApi = GlobalVariable.BASE_PATH + "/rest/gas/delete";

// 查询气体记录
const searchSensorRecordApi = GlobalVariable.BASE_PATH + "/rest/gas/record/search";

// 查询气体报警
const searchSensorAlarmApi = GlobalVariable.BASE_PATH + "/rest/gas/alarm/search";

// 查询气体类型
const searchSensorTypeApi = GlobalVariable.BASE_PATH + "/rest/gas/searchType";


export default {
    // 查询气体
    searchSensorApi,
    // 添加气体
    addSensorApi,
    // 修改气体
    updateSensorApi,
    // 删除气体
    deleteSensorApi,
    // 查询气体记录
    searchSensorRecordApi,
    // 查询气体报警
    searchSensorAlarmApi,
    // 查询气体类型
    searchSensorTypeApi
}


// WEBPACK FOOTER //
// ./src/request/api-gas.js